import React from 'react';
import AuthService from './authService';
import EvaluatorLeadAdminItem from '../Domain/EvaluatorLeadAdminItem';
import SearchParams from '../Elements/SearchParams';
import OrderDirectionsEnum from '../Enums/OrderDirectionsEnum';
import EvaluatorLeadSearchParams from '../Contents/ThirdParty/EvaluatorLead/EvaluatorLeadSearchParams';

export default class EvaluatorLeadService extends React.Component {
  static async GetUploadTemplate() {
    const url = `/api/Template/GetTemplate?templateName=${encodeURIComponent('Evaluator Lead Upload Template')}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(
      searchItem,
      EvaluatorLeadSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );
    return AuthService.getInstance().CallBackendFunction(
      `/api/EvaluatorLead/GetListBySearchingAsync?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`
    );
  }

  // Exports the list the user is looking at: the same search item and ordering the list call
  // uses, so the file holds the same rows. The backend widens the paging to the whole result set.
  static ExportListToExcel(searchItem) {
    const searchParams = new SearchParams(
      searchItem,
      EvaluatorLeadSearchParams,
      'EvaluatorLeadId',
      OrderDirectionsEnum.Desc
    );
    return AuthService.getInstance().CallBackendFunctionPost(
      '/api/EvaluatorLead/ExportListToExcel',
      searchParams.serializeForBackendCall()
    );
  }

  static AnonymizeById(evaluatorLeadId) {
    return AuthService.getInstance().CallBackendFunctionPost(
      `/api/EvaluatorLead/AnonymizeByIdAsync/${evaluatorLeadId}`
    );
  }

  static CreateEvaluatorLead(evaluatorLead) {
    return AuthService.getInstance().CallBackendFunctionPost('/api/EvaluatorLead/CreateEvaluatorLead', evaluatorLead);
  }

  static UpdateEvaluatorLead(evaluatorLead) {
    return AuthService.getInstance().CallBackendFunctionPost('/api/EvaluatorLead/UpdateEvaluatorLead', evaluatorLead);
  }

  // Create when there is no id yet, otherwise update the existing (manually created) lead.
  static SaveEvaluatorLead(evaluatorLead) {
    return evaluatorLead.EvaluatorLeadId
      ? EvaluatorLeadService.UpdateEvaluatorLead(evaluatorLead)
      : EvaluatorLeadService.CreateEvaluatorLead(evaluatorLead);
  }

  static ConvertDBItems(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => {
        convertedItems.push(new EvaluatorLeadAdminItem(item));
      });
    }
    return convertedItems;
  }

  static async RequestEvaluatorLeadReport(params) {
    const url = '/api/EvaluatorLead/RunEvaluatorLeadReport';
    if (params.LeadListFile instanceof File) {
      const formData = new FormData();
      formData.append('file', params.LeadListFile);
      return AuthService.getInstance().CallBackendFunctionPostFile(`${url}NewFile`, formData);
    }
    return AuthService.getInstance().CallBackendFunctionPost(url, JSON.stringify(params));
  }
}
